module.exports = __webpack_public_path__ + "img/shipma.e8af5784.png";